export const POLYGON_SVG_PATHS: Record<string, string> = {
  tetrahedron_diamond: `M 80.0514 25.6679
    C 91.0686 14.6507 108.928 14.6508 119.948 25.6679
    L 174.332 80.0514
    C 185.349 91.0686 185.349 108.928 174.332 119.948
    L 119.948 174.332
    C 108.928 185.349 91.0686 185.349 80.0514 174.332
    L 25.6679 119.948
    C 14.6507 108.928 14.6507 91.0686 25.6679 80.0514
    L 80.0514 25.6679
    Z`,

  pentagon: `M 83.133 20.3879
    C 93.0207 13.204 106.309 13.204 116.198 20.3879
    L 173.049 61.4388
    C 182.937 68.6227 187.075 81.3563 183.348 93.9803
    L 161.466 160.401
    C 157.739 173.025 146.858 181.395 133.385 181.395
    L 64.7954 181.395
    C 51.3218 181.395 40.4418 173.025 36.7148 160.401
    L 14.832 93.9803
    C 11.105 81.3563 15.2431 68.6227 25.1311 61.4388
    L 83.133 20.3879
    Z`,

  hexagon: `M 86.062 14.004
    C 94.708 8.974 105.478 8.974 114.124 14.004
    L 168.049 44.977
    C 176.695 50.007 181.821 59.106 181.821 69.176
    V 129.215
    C 181.821 139.284 176.695 148.383 168.049 153.414
    L 114.124 184.387
    C 105.478 189.417 94.708 189.417 86.062 184.387
    L 32.138 153.414
    C 23.491 148.383 18.366 139.284 18.366 129.215
    V 69.176
    C 18.366 59.106 23.491 50.007 32.138 44.977
    L 86.062 14.004
    Z`,

  heptagon: `M 86.1912 12.0438
    C 93.9265 8.25624 103.0758 8.25624 110.811 12.0438
    L 159.597 35.252
    C 167.328 39.0354 172.834 46.1408 174.782 54.5796
    L 186.45 108.914
    C 188.399 117.352 186.321 126.25 181.025 132.906
    L 147.779 175.99
    C 142.483 182.646 134.557 186.561 126.002 186.561
    H 70.9709
    C 62.4155 186.561 54.4893 182.646 49.1939 175.99
    L 15.9772 132.906
    C 10.6819 126.25 8.60404 117.352 10.5529 108.914
    L 22.2211 54.5796
    C 24.1699 46.1408 29.6754 39.0354 37.4079 35.252
    L 86.1912 12.0438
    Z`,
};
